module.exports = __webpack_public_path__ + "static/media/YF06_0.6ffd31f0.jpg";